import React from 'react';
import { Home, Tent, Caravan, Wifi, Zap, Check } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';

const Accommodation = () => {
  const accommodationTypes = [
    {
      icon: Home,
      title: 'Dřevěné chatky',
      description: 'Komfortní ubytování pro rodiny a skupiny',
      capacity: 'Max. 30 lůžek',
      image: 'https://i.ibb.co/39Nc2B3t/IMG-20260408-WA0004.jpg',
      features: ['Vytápění', 'WiFi', 'Lůžkoviny', 'Zásuvky'],
      priceFrom: '350 Kč/osoba/noc',
      color: 'emerald'
    },
    {
      icon: Tent,
      title: 'Stanové místa',
      description: 'Rovinatý terén ideální pro stany',
      capacity: 'Cca 50 míst',
      image: 'https://i.ibb.co/m3rRG3p/IMG-20260408-WA0010.jpg',
      features: ['Elektrické přípojky', 'Blízko sociálního zařízení', 'Ohniště', 'Stín stromů'],
      priceFrom: '130 Kč/stan/noc',
      color: 'amber'
    },
    {
      icon: Caravan,
      title: 'Karavany & Obytná auta',
      description: 'Prostorná místa s kompletním vybavením',
      capacity: 'Cca 20 míst',
      image: 'https://i.ibb.co/5gCbPX6c/IMG-20260408-WA0006.jpg',
      features: ['Elektrická přípojka', 'Přípojka vody', 'Výlevka pro chemické WC', 'Rovný povrch'],
      priceFrom: '250 Kč/karavan/noc',
      color: 'blue'
    }
  ];

  return (
    <section id="accommodation" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Ubytování
          </h2>
          <div className="w-24 h-1 bg-emerald-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600">
            Nabízíme různé možnosti ubytování pro každý typ návštěvníka - od komfortních chatek 
            až po prostorná místa pro karavany
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
          {accommodationTypes.map((type, index) => (
            <Card
              key={index}
              className="group overflow-hidden hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border-2 border-gray-100 hover:border-emerald-300"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={type.image}
                  alt={type.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                
                <div className="absolute top-4 right-4 bg-white rounded-full p-3 shadow-lg">
                  <type.icon className="w-6 h-6 text-emerald-600" />
                </div>

                <div className="absolute bottom-4 left-4">
                  <Badge className="bg-emerald-600 hover:bg-emerald-700 text-white text-sm px-4 py-2">
                    Od {type.priceFrom}
                  </Badge>
                </div>
              </div>

              <CardHeader>
                <CardTitle className="text-2xl text-gray-900 mb-2">
                  {type.title}
                </CardTitle>
                <p className="text-gray-600 text-sm mb-1">
                  {type.description}
                </p>
                <p className="text-emerald-600 font-semibold text-sm">
                  {type.capacity}
                </p>
              </CardHeader>

              <CardContent>
                <div className="space-y-2">
                  {type.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center space-x-2">
                      <Check className="w-4 h-4 text-emerald-600 flex-shrink-0" />
                      <span className="text-sm text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Card className="bg-gradient-to-br from-emerald-50 to-emerald-100 border-emerald-200">
            <CardContent className="p-6">
              <div className="flex items-start space-x-4">
                <div className="bg-emerald-600 rounded-full p-3">
                  <Wifi className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    WiFi v celém areálu
                  </h3>
                  <p className="text-gray-700">
                    Výborný signál WiFi dostupný ve všech chatách i na stanovištích zdarma
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-gradient-to-br from-amber-50 to-amber-100 border-amber-200">
            <CardContent className="p-6">
              <div className="flex items-start space-x-4">
                <div className="bg-amber-600 rounded-full p-3">
                  <Zap className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    Elektrické přípojky
                  </h3>
                  <p className="text-gray-700">
                    Dostupné pro stany i karavany za příplatek 100 Kč/den
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Accommodation;
